import { render, staticRenderFns } from "./LinkBankBTN.vue?vue&type=template&id=7bf183a7&scoped=true"
import script from "./LinkBankBTN.vue?vue&type=script&lang=js"
export * from "./LinkBankBTN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf183a7",
  null
  
)

export default component.exports